module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.vehicles && _vm.vehicles.length) ? _c('div', _vm._l((_vm.vehicles), function(item) {
    return _c('div', {
      key: item.contactVehicleId,
      staticClass: "vehicle",
      on: {
        "click": function($event) {
          return _vm.$emit('onVehicleClick', item)
        }
      }
    }, [(item.imageUrl) ? _c('app-image', {
      staticClass: "image",
      attrs: {
        "imageUrl": item.imageUrl,
        "alt": 'vehicle image'
      }
    }) : _vm._e(), _vm._v(" "), _c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.year) + " " + _vm._s(item.make) + " " + _vm._s(item.model))]), _vm._v(" "), (item.vin) ? _c('p', {
      staticClass: "subtitle"
    }, [_vm._v("\n        VIN: "), _c('span', [_vm._v(_vm._s(item.vin))])]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "actions"
    }, [(item.ownerManualUrl) ? _c('li', [_c('a', {
      attrs: {
        "href": item.ownerManualUrl,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation(); {}
        }
      }
    }, [_c('span', {
      staticClass: "dbc-icon dbc-icon-document-header"
    }), _vm._v("Get owners\n            manual")])]) : _vm._e(), _vm._v(" "), (item.brochureUrl) ? _c('li', [_c('a', {
      attrs: {
        "href": item.brochureUrl,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation(); {}
        }
      }
    }, [_c('span', {
      staticClass: "dbc-icon dbc-icon-book"
    }), _vm._v("Get brochure")])]) : _vm._e(), _vm._v(" "), (item.myVehicleWorth) ? _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.$emit('whyMyCarWorth', item.myVehicleWorth)
        }
      }
    }, [_c('span', {
      staticClass: "dbc-icon dbc-icon-tools"
    }), _vm._v("What`s my vehicle\n            worth?")])]) : _vm._e(), _vm._v(" "), (item.scheduleServiceLink) ? _c('li', [_c('a', {
      attrs: {
        "href": item.scheduleServiceLink,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation(); {}
        }
      }
    }, [_c('span', {
      staticClass: "dbc-icon dbc-icon-map_car-dealer"
    }), _vm._v("Schedule\n            service")])]) : _vm._e()])], 1)
  }), 0) : _c('no-vehicles', {
    attrs: {
      "vehiclesCategory": 'purchased'
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2fa2aa71", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fa2aa71"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/garage/garage-vehicles-list.vue
// module id = 760
// module chunks = 0